import { ConditionTreeController } from './conditionTree.controller';

const conditionTreeHtml = require('./conditionTree.html');

/* @ngInject */
export function conditionTreeDirective(): ng.IDirective {
  return {
    restrict: 'E',
    scope: {
      conditions: '=',
      models: '=',
      isEditing: '=',
      isChildEditing: '=',
      isRoot: '=',
      detailsVisible: '='
    },
    templateUrl: conditionTreeHtml,
    controller: ConditionTreeController,
    controllerAs: 'conditionTreeCtrl',
    replace: true
  };
}
